import { useNavigate } from "@tanstack/react-router"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useCreateInstagramIntegrationMutation } from "modules/settings/hooks/instagram/useCreateInstagramIntegrationMutation"
import { Loading } from "modules/shared/components/Loading"
import { useCallback, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { Route as AddInstagramIntegrationRoute } from "routes/_base/_auth/settings/channels/instagram/new"

export const AddInstagramIntegration = () => {
  const hasAlreadyValidated = useRef(false)
  const { t } = useTranslation()
  const { code } = AddInstagramIntegrationRoute.useSearch()
  const navigate = useNavigate()
  const { mutateAsync } = useCreateInstagramIntegrationMutation()

  const onOpenChange = useCallback(
    (isOpen: boolean = false) => {
      if (!isOpen) {
        navigate({ to: "/settings/channels/instagram" })
      }
    },
    [navigate],
  )

  useEffect(() => {
    if (!hasAlreadyValidated.current) {
      hasAlreadyValidated.current = true
      mutateAsync({ code }).then(() => {
        onOpenChange(false)
      })
    }
  }, [mutateAsync, code, hasAlreadyValidated, onOpenChange])

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.instagram.addIntegration.title")}</DialogTitle>
          <DialogDescription>
            {t("settings.integrations.instagram.addIntegration.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <Loading size={6} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
